﻿import './Home.scss';

import './HomeBanner/HomeBanner.jsx';

// Components
import '../Components/Video/Video.scss';
import '../Components/Reviews/Reviews.scss';
import '../Components/Reviews/ReviewsCarousel/ReviewsCarousel';
import '../Components/Reputation/ReputationCarousel/ReputationCarousel';
import '../Components/GoogleReviews/GoogleReviewsCarousel/GoogleReviewsCarousel';

import '../Components/YelpReviews/YelpReviewsCarousel/YelpReviewsCarousel';
import '../Components/Services/Services.scss';
import '../Components/Location/Location.scss';
import '../Components/Location/LocationMap/LocationMap';
import '../Components/SimpleText/SimpleText.scss';
import '../Components/DemandForce/DemandForce.scss';
import '../Components/Coupons/CouponsCarousel/CouponsCarousel';
import '../Components/Coupons/Coupons.scss';
import '../Components/Facebook/Facebook';
import '../Components/CallForm/CallForm/CallForm';
import '../Components/CallForm/CallForm.scss';
import '../Components/HighLight/HighLight.scss';

import '../Components/ImageGallery/ImageGallery';
import '../Components/PhotoGallery/PhotoGallery';
import '../Components/PhotoGallery/PhotoGallery.scss';

// shared styles
import '../Shared/Form/Inputs/Inputs.scss';

import ModalVideo from '../Shared/ModalVideo/ModalVideo';

const video = new ModalVideo();
video.init();


// WEBPACK FOOTER //
// ./Src/Home/Home.js